<template>
  <div :class="$style.loading"></div>
</template>

<style scoped module lang="scss">
.loading {
  width: 100%;
  height: 100%;
  @include background-skeleton-loading;
}
</style>
